import React from 'react';
import classNames from 'classnames';

import { FormattedMessage } from '../../util/reactIntl';
import NamedLink from '../NamedLink/NamedLink';

import css from './IdentityRequiredNotice.module.css';

const CONTEXT_IDS = {
  publish: 'Identity.requiredPublish',
  book: 'Identity.requiredBook',
  join: 'Identity.requiredJoin',
  message: 'Identity.requiredMessage',
  listing: 'Identity.listingUnverified',
  default: 'Identity.requiredDefault',
};

const IdentityRequiredNotice = props => {
  const { context = 'default', className } = props;
  const messageId = CONTEXT_IDS[context] || CONTEXT_IDS.default;
  const showSettingsLink = context !== 'listing';

  return (
    <div className={classNames(css.root, className)} role="status">
      <p className={css.body}>
        <FormattedMessage id={messageId} />
      </p>
      {showSettingsLink ? (
        <NamedLink
          className={css.link}
          name="YourProfilePage"
          to={{ search: '?tab=talking', hash: 'identity' }}
        >
          <FormattedMessage id="Identity.openSettings" />
        </NamedLink>
      ) : null}
    </div>
  );
};

export default IdentityRequiredNotice;
